"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Axios = exports.messages = void 0;
const axios_1 = __importDefault(require("axios"));
exports.messages = {
    400: 'Bad Request',
    401: 'Unauthorized',
    404: 'Not Found',
    405: 'Method Not Allowed',
    422: 'Unprocessable Entity',
    429: 'Too many requests',
    500: 'Internal Server Error',
    502: 'Bad Gateway Error',
};
const defaultErrorMessage = 'Unexpected Error';
axios_1.default.interceptors.response.use((response) => {
    var _a;
    // Если в запросе со статусом 200 есть поле error считаем такой запрос ошибочный
    if (response.status === 200 && ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.error)) {
        throw {
            error: response.data.error,
            status: response.status,
            data: response.data
        };
    }
    return response;
}, (error) => {
    var _a, _b, _c, _d;
    // Если пришёл ответ от сервера, то обрабатываем его
    if (error === null || error === void 0 ? void 0 : error.response) {
        if (typeof ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) !== 'object') {
            error.response.data = {};
        }
        if (!((_b = error.response.data) === null || _b === void 0 ? void 0 : _b.message)) {
            error.response.data.message = exports.messages[(_c = error.response) === null || _c === void 0 ? void 0 : _c.status] || defaultErrorMessage;
        }
        return Promise.reject({
            message: error.response.data.message,
            status: (_d = error.response) === null || _d === void 0 ? void 0 : _d.status,
            data: error.response.data,
            responseError: error
        });
    }
    // Иначе это ошибка Axios
    return Promise.reject({ message: error.message || defaultErrorMessage, responseError: error });
});
exports.Axios = axios_1.default;
